(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["you-may-also-like"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('random-product-recommendations')) {
    customElements.define(
      'random-product-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          this.renderRandomProducts();
          this.handlePageShow = (event) => {
            if (event.persisted) this.renderRandomProducts();
          };
          window.addEventListener('pageshow', this.handlePageShow);
        }
        disconnectedCallback() {
          window.removeEventListener('pageshow', this.handlePageShow);
        }
        renderRandomProducts() {
          const grid = this.querySelector('[data-random-products-grid]');
          const empty = this.querySelector('[data-random-products-empty]');
          const templates = Array.from(this.querySelectorAll('template[data-random-product]'));
          const count = Math.min(Number(this.dataset.count) || 12, templates.length);
          for (let index = templates.length - 1; index > 0; index -= 1) {
            const randomIndex = Math.floor(Math.random() * (index + 1));
            [templates[index], templates[randomIndex]] = [templates[randomIndex], templates[index]];
          }
          grid.replaceChildren();
          templates.slice(0, count).forEach((template) => {
            grid.appendChild(template.content.cloneNode(true));
          });
          empty.hidden = count > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
